import Highcharts from "highcharts";
import { useMemo } from "react";
import { THEME_MODE } from "src/config/constants";
import { COLOR_ARRAY } from "src/config/styleConfig";
import { useConfigContext } from "src/context/config/configContext";
import { hexToRgb } from "src/services/utils";
import BaseScoringChart from "./BaseScoringChart";

export default function AreaChart({ series, isLoading, option, ...props }) {
  const { themeMode } = useConfigContext();

  function _makeSeries(series) {
    let finalSeries = [];

    let index = 0;
    for (var item of series) {
      const _color = COLOR_ARRAY[index];
      const { r, g, b } = hexToRgb(_color);
      const shadowColor = `rgba(${r}, ${g}, ${b}, 0.1)`;
      const beginOpacity = themeMode === THEME_MODE.DARK ? 1 : 0.7;
      finalSeries.push({
        ...item,
        ...{
          lineColor: `rgba(${r}, ${g}, ${b}, ${beginOpacity})`,
          marker: {
            lineWidth: 1,
            lineColor: `rgba(${r}, ${g}, ${b}, ${beginOpacity})`,
            fillColor: `rgba(${r}, ${g}, ${b}, ${beginOpacity})`,
          },
          fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, `rgba(${r}, ${g}, ${b}, ${beginOpacity})`],
              [1, shadowColor],
            ],
          },
        },
      });
      index++;
    }
    return finalSeries;
  }

  const options = useMemo(() => {
    return Highcharts.merge(
      {
        chart: {
          type: "area",
        },
        title: {
          text: undefined,
        },
        yAxis: {
          labels: {
            enabled: false,
          },
          title: {
            text: undefined,
          },
          gridLineWidth: 0,
        },
        xAxis: {
          crosshair: {
            color: "#7E94BD",
            width: 1,
          },
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
            },
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 2,
              },
            },
            threshold: null,
          },
        },
        series: _makeSeries(series),
        tooltip: {
          enabled: true,
          shared: true,
          style: {
            display: "none",
          },
        },
        legend: {
          enabled: false,
        },
      },
      option
    );
  }, [series, option]);

  return <BaseScoringChart isLoading={isLoading} highcharts={Highcharts} options={options} {...props} />;
}
